/* eslint-disable react/require-default-props */
import React from 'react';
import { useTranslation } from 'react-i18next';

export interface AttendanceCardProps {
  createdAt: string;
  isOpened?: boolean;
  number: string;
  status?: string;
  subject: string;
}

const AttendanceCard: React.FC<AttendanceCardProps> = ({
  createdAt,
  isOpened: inheritedIsOpened = false,
  number,
  status,
  subject,
}) => {
  const [isOpened, setIsOpened] = React.useState(false);
  const [statusTimeline, setStatusTimeline] = React.useState([
    {
      name: 'Novo',
      isCompleted: true,
    },
    {
      name: 'Aberto',
      isCompleted: false,
    },
    {
      name: 'Em espera',
      isCompleted: false,
    },
    {
      name: 'Pendente',
      isCompleted: false,
    },

    {
      name: 'Resolvido',
      isCompleted: false,
    },
    {
      name: 'Fechado',
      isCompleted: false,
    },
  ]);

  React.useEffect(() => {
    if (status === 'Aberto') {
      const newStatus = [...statusTimeline];
      newStatus[1].isCompleted = true;
      setStatusTimeline(newStatus);
    }
    if (status === 'Em espera') {
      const newStatus = [...statusTimeline];
      newStatus[1].isCompleted = true;
      newStatus[2].isCompleted = true;
      newStatus[3].isCompleted = true;
      setStatusTimeline(newStatus);
    }
    if (status === 'Pendente') {
      const newStatus = [...statusTimeline];
      newStatus[1].isCompleted = true;
      newStatus[2].isCompleted = true;
      setStatusTimeline(newStatus);
    }
    if (status === 'Resolvido') {
      const newStatus = [...statusTimeline];
      newStatus[1].isCompleted = true;
      newStatus[2].isCompleted = true;
      newStatus[3].isCompleted = true;
      newStatus[4].isCompleted = true;
      setStatusTimeline(newStatus);
    }
    if (status === 'Fechado') {
      const newStatus = [...statusTimeline];
      newStatus[1].isCompleted = true;
      newStatus[2].isCompleted = true;
      newStatus[3].isCompleted = true;
      newStatus[4].isCompleted = true;
      newStatus[5].isCompleted = true;
      setStatusTimeline(newStatus);
    }
  }, [status]);

  React.useEffect(() => {
    setIsOpened(inheritedIsOpened);
  }, [inheritedIsOpened]);

  const formatDate = (date: string) => {
    const dateParse = new Date(date);
    return dateParse.toISOString().slice(0, 10).split('-').reverse().join('/');
  };

  const { t } = useTranslation('list_attendance');

  const renderTimelineStatus = (label: string, isCompleted: boolean) => (
    <div
      className={`vbz-attendance-card__timeline__status
      ${isCompleted ? 'vbz-attendance-card__timeline__status--completed' : ''}`}
      key={label}
    >
      <div className="vbz-attendance-card__timeline__status__dot">
        <span className="vbz-attendance-card__timeline__status__label">{label}</span>
      </div>
    </div>
  );

  return (
    <div className={`vbz-attendance-card ${isOpened ? 'vbz-attendance-card--opened' : ''}`}>
      <div className="vbz-attendance-card__content">
        <div className="vbz-attendance-card__content__cell--date">
          <span className="vbz-attendance-card__content__cell__label">{t('date')}</span>
          <span>{formatDate(createdAt)}</span>
        </div>
        <div className="vbz-attendance-card__content__cell--number">
          <span className="vbz-attendance-card__content__cell__label">{t('attendance')}</span>
          <span>{number}</span>
        </div>
        <div className="vbz-attendance-card__content__cell--subject">
          <span className="vbz-attendance-card__content__cell__label">{t('subject')}</span>
          <span>{subject}</span>
        </div>
        <div className="vbz-attendance-card__content__cell--status">
          <span className="vbz-attendance-card__content__cell__label">{t('status')}</span>
          <span>{status}</span>
        </div>
        <button
          type="button"
          className="vbz-attendance-card__content__expand-button"
          onClick={() => setIsOpened((value) => !value)}
          data-testid="expand-button"
        >
          <i className="material-icons">{isOpened ? 'expand_less' : 'expand_more'}</i>
        </button>
      </div>

      {isOpened && (
        <div className="vbz-attendance-card__timeline" data-testid="card-timeline">
          {statusTimeline.map((item) => renderTimelineStatus(item.name, item.isCompleted))}
        </div>
      )}
    </div>
  );
};

export default AttendanceCard;
